import React from "react";
import "./index.css";

function Footer() {
  return (
    <footer className="footer">
      <h5>Get in Touch</h5>
      <h1>Contact Me</h1>
      <div className="contac--vv">
        <i className="ri-mail-fill"></i>
        <a href="mailto: ajaygoud057@gmail.com">ajaygoud057@gmail.com</a>
        <i className="ri-linkedin-box-fill"></i>
        <a href="https://in.linkedin.com/in/ajaydev01">LinkedIn</a>
      </div>

      <h4>Copyright &copy; 2026 Ajay Goud. All Rights Reserved. </h4>
    </footer>
  );
}

export default Footer;
